<template>
  <div>
    <v-tour
      :callbacks="{ onStart, onFinish }"
      name="tourAfterCreateOrder"
      :steps="steps"
      :options="{ labels: { buttonStop: $t('gotIt') } }"
    ></v-tour>
  </div>
</template>

<script>
const key = "DepartmentOrderCreateOrderTour";
export default {
  data() {
    return {
      justCreatedOrder: false,
      steps: [
        {
          target: "[data-test='divisionOrders-order-0-send-btn']", // We're using document.querySelector() under the hood
          content: ` <strong>${this.$t("hintSendOrderAfterCreate")}</strong>!`,
          params: {
            enableScrolling: false,
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [10, 10],
                },
              },
            ],
            placement: "bottom", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
      ],
    };
  },
  methods: {
    onCreatedOrder() {
      this.justCreatedOrder = true;
    },
    onFinish() {
      localStorage.setItem(key, "finished");
    },
    onStart() {
      const parent = document.getElementById("departmentOrderTable");
      const child = document.querySelector(
        "[data-test='divisionOrders-order-0-send-btn']"
      );
      parent.scrollLeft =
        child.getBoundingClientRect().left -
        parent.getBoundingClientRect().left -
        parent.offsetWidth +
        250;
    },

    start() {
      if (!localStorage.getItem(key)) {
        setTimeout(() => {
          this.$tours["tourAfterCreateOrder"].start();
        }, 500);
      }
    },
  },
};
</script>
